var _ = require('underscore');
var $ = require('jquery')
if (window.addEventListener) {
    window._k_report_error = [];
    window._k_report_options = {}
    window.addEventListener('error', function(e) {
        window._k_report_error.push(e);
        return true
    }, true)
};
if (!window.loggingPlugin) {
    window.loggingPlugin = {
        options: {
            app_name: 'K-Logging',
            open_level: ['info', 'warn', 'error'],
            method: ['', '', ''],
        },
        preDebug: [],
        prefInfo: [],
        prefWarn: [],
        prefError: [],
        listenerStatus: {},
        debug: function() {
            window.loggingPlugin.preDebug.push(arguments)
        },
        info: function() {
            window.loggingPlugin.prefInfo.push(arguments)
        },
        warn: function() {
            window.loggingPlugin.prefWarn.push(arguments)
        },
        error: function() {
            window.loggingPlugin.prefError.push(arguments)
        }
    }

    window.onerror = function(msg, url, lineNo, columnNo, error) {
        var string = msg.toLowerCase()
        var substring = 'script error'
        if (string.indexOf(substring) > -1) {
            window.loggingPlugin.error('Script Error: See Browser Console for Detail')
        } else {
            var message = [
                'Message: ' + msg,
                'URL: ' + url,
                'Line: ' + lineNo,
                'Column: ' + columnNo,
                'Error object: ' + JSON.stringify(error)
            ].join(' - ')

            window.loggingPlugin.error(message)
        }

        return false
    }

    var jqueryDocument = $ && $(document);
    if (jqueryDocument && jqueryDocument.ajaxComplete) {
        window.loggingPlugin.listenerStatus.jqueryAjax = true
        jQuery.ajaxPrefilter("script", function(s) {
            s.global = true;

        });
        jqueryDocument.ajaxComplete(function(event, request, settings) {
            if (!request) request = {}
            var result = {
                category: 'k-logging',
                name: 'jqueryAjaxComplete',
                data: {
                    url: settings.url,
                    responseJSON: request.responseJSON,
                    readyState: request.readyState,
                    status: request.status
                }
            }
            window.loggingPlugin.info(JSON.stringify(result))
        })
    }
}

require('./common/config.js');
var tj = require('./common/tj.js');
var main = require('./common/main.js');
var msgbox = require('./common/msgbox.js');
var user = require('./common/user.js');
var login = require('./common/login.js');
var util = require('./common/util.js');
var logistics = require('./tools/logistics.js');
var vcode = require('./tools/vcode.js');

require('./tools/lottery.js');
require('./tools/textSlider.js');

$(document).on('click', '.act_vip', function() {
    var payId = $(this).attr('payid');
    var payTitle = $(this).attr('paytitle');

    if (payId) {
        var payIds = {};
        var payIdArr = payId.split(',');
        if (payIdArr.length == 1) {
            pay(payId);
        } else if (payTitle) {
            var payTitleArr = payTitle.split(',');
            if (payIdArr.length == payTitleArr.length) {
                for (var i = 0, len = payIdArr.length; i < len; i++) {
                    payIds[payIdArr[i]] = payTitleArr[i];
                }
            }

            pay(payIdArr[0], payIds);
        }
    } else {
        pay();
    }
}).on('click', '.act_logistics', function() {
    logistics();
}).on('click', '.act_prize, act_prize_list', function() {
    prizelist();
}).on('click', '.act_address', function() {
    address();
}).on('click', '.act_info', function() {
    var gid = $(this).attr('gid');
    info(gid);
}).on('click', '.phone_message_get', function() {
    var gid = $(this).attr('gid') || null;
    var url = $(this).attr('data-url');
    var actid = $(this).attr('data-actid');
    vcode({
        gid: gid,
        url: url,
        actid: actid
    });
});

var pay = function(pid, pids) {
    require.ensure(['./tools/vippay.js'], function(require) {
        var pay = require('./tools/vippay.js');
        pay(pid, pids);
    }, 'vippay');
}

pay.after = function(fn) {
    require.ensure('./tools/vippay.js', function(require) {
        var pay = require('./tools/vippay.js');
        pay.after(fn);
    }, 'vippay');
}

var prizelist = function() {
    require.ensure('./tools/prizelist.js', function(require) {
        var prizelist = require('./tools/prizelist.js');
        prizelist();
    }, 'prizelist');
}

var address = function() {
    require.ensure('./tools/prizelist.js', function(require) {
        var prizelist = require('./tools/prizelist.js');
        prizelist.address();
    }, 'prizelist');
}

var info = function(gid) {
    require.ensure('./tools/prizelist.js', function(require) {
        var prizelist = require('./tools/prizelist.js');
        prizelist.info(gid);
    }, 'prizelist');
}

window.thunder = function(options, fn) {
    var allModules = {
        _: _,
        util: util,
        main: main,
        msgbox: msgbox,
        user: user,
        login: login,
        pay: pay,
        tj: tj.tj,
        xlaInit: tj.xlaInit,
        prizelist: prizelist,
        address: address,
        info: info,
        log: window.loggingPlugin
    };

    var optType = getOriginalType(options);
    if (optType === 'function') {
        fn = options;
    } else if (optType === 'object') {
        if (getOriginalType(options.thunderInit) === 'function') {
            // 各模块初始化
            options.thunderInit.call(allModules);
        }
    }

    if (!window.xla) {
        // 如果初始化中没有初始化这个，则需要自动初始化
        tj.xlaInit();
    }

    $(function() {
        fn.call(allModules);
        main.start();
        window.thunder === null;
    });
}

function getOriginalType(obj) {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
}



//////////////////
// WEBPACK FOOTER
// ./src/entry.js
// module id = 9
// module chunks = 2